{/* // ---ハンバーガーメニュークリック時の変化（hiraku） */}
/*==================================================
hiraku
==================================================*/
$(function () {
	$(".js-hiraku-offcanvas-sidebar-right").hiraku({
			fixedHeader: ".header",
			btn: ".hiraku-open-btn",
			direction: "right",
			width: '250px'
	});
});


// 読み込み時のチラつきがあったため読み込みが終わったら表示
$(document).ready(function(){
	$('.offcanvas-right').css('display' , 'block');
});
